
  import qs from 'qs'
  import {Toast} from 'vant'

  export default {
    name: "telecontrol.vue",
    data() {
      return {
        orderNum: '',
        list: [],
        selectParent: false,
        name: this.$t('append_field.selectDevice'),
        delesId: "",
        clientNo: "",
        isRed: true,
        fontRed: 'color: red',
        fontWhite: 'color: #fff',

        isVisible1: false,
        menuItems2: [],
        isRound: false,
        activeNames2: '',
        chooseEquipArr: [],
        radio: '',
        sendTaskId: '',
        seletedEquip: {},
        dataList: [],
        doch: 0,
        data: [],
        index: 0,
      }
    },
    computed: {},
    mounted() {
      this.doch = window.screen.height

    },
    methods: {
      back() {
        this.$router.push({path: '/my'})
      },
      RemoteFunc: function (res) {
        if (this.name === "" || this.name === this.$t('append_field.selectDevice')) {
          let options = {
            message: this.$t('append_field.selectDevice'),
            duration: 2000,
            type: "danger"
          };
          Toast(options)
          return
        }


        if (res === 'powenOn') {
          this.orderNum = '7001'
        } else if (res === 'voiceDown') {
          this.orderNum = '7003'
        } else if (res === 'voiceUp') {
          this.orderNum = '7002'
        } else if (res === 'muteOn') {
          this.orderNum = '7011'
        } else if (res === 'up') {
          this.orderNum = '7004'
        } else if (res === 'left') {
          this.orderNum = '7006'
        } else if (res === 'middle') {
          this.orderNum = '7008'
        } else if (res === 'right') {
          this.orderNum = '7007'
        } else if (res === 'down') {
          this.orderNum = '7005'
        } else if (res === 'back') {
          this.orderNum = '7012'
        } else if (res === 'menu') {
          this.orderNum = '7009'
        } else if (res === 'home') {
          this.orderNum = '7010'
        } else if (res === 'app') {
          this.orderNum = ''
        }


        this.$ajax.post("/etv/appletsRemote.json", qs.stringify({
          instruction: this.orderNum,
          clientNo: this.seletedEquip.clNo,
          id: this.seletedEquip.clId

        })).then(res => {
          if (res.data.code === 0) {
            Toast({type: 'success', message: res.data.msg});
          } else {
            Toast({type: 'danger', message: res.data.msg});
          }
        })
      },
      showSend() {
        this.isVisible1 = true
        this.$ajax.post("/etv/selectSeachClientTreeMobile.json", {
          groupParentId: "",
          type: "",
          onlineState: "",
          clientName: ""
        }).then(res => {
          if (res.data.code === 0) {
            this.menuItems2 = res.data.data;
            // this.dataList = res.data.data;
          }
          const Terminal = document.getElementsByClassName('scroll')[0]

          Terminal.addEventListener('scroll', this.handleScroll)
        })
      },

      onCollapseChange(activeNames2) {
        this.index = 0
        if (activeNames2 === '') {
          return
        }
        this.activeNames2 = activeNames2
        if (this.menuItems2[this.activeNames2].children.length > 0) {
          this.data = this.menuItems2[this.activeNames2].children.slice(this.index, 15)
        } else {
          this.data = []
        }
      },

      toggle(r1) {

        this.radio = r1.clId
        this.seletedEquip = r1
      },
      closeGroup() {
        this.isVisible1 = false;
        this.menuItems2 = []
      },
      confirmSend() {
        if (this.radio == '') {
          Toast(this.$t('append_field.selectDevice'))
          return
        }

        this.name = this.seletedEquip.name
        this.isVisible1 = false
        this.isRed = false

      },
      goBack() {
        this.$router.push({path: '/my'})
      },
      handleScroll() {
        //滚动条
        const scrollHeight = document.getElementsByClassName('scroll')[0].scrollTop
        let clientHeight = document.getElementsByClassName('scroll-a')[0].clientHeight
        //真实高度
        if (clientHeight - this.doch - scrollHeight + 70 < 40) {
          if (this.menuItems2[this.activeNames2].children.slice(this.index * 15, this.index * 15 + 15).length < 15) {
            return
          }
          this.index++
          this.data = [...this.data, ...this.menuItems2[this.activeNames2].children.slice(this.index * 15, this.index * 15 + 15)]
        }
      },
    }
  }
